import React from 'react';
import type { BaseWorkflowRoutingIslandProps } from '../types';
import BaseSimpleIsland from '../../BaseSimpleIsland';
import OnIslandWorkflowRoutingNode from '../OnIslandWorkflowRoutingNode';


interface SimpleWorkflowRoutingIslandProps extends BaseWorkflowRoutingIslandProps { }

export default function SimpleWorkflowRoutingIsland({
  workflowRoutingActions,
}: SimpleWorkflowRoutingIslandProps) {
  return (
    <BaseSimpleIsland
      Node={OnIslandWorkflowRoutingNode}
      actions={workflowRoutingActions}
    />
  );
}
